import Vue from 'vue';
import VueRouter from 'vue-router';
import { getToken } from '@/utils/auth';
import request from '@/utils/request';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginPage.vue'),
    meta: { public: true },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/RegisterPage.vue'),
    meta: { public: true },
  },
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '数据总览' },
      },
      {
        path: 'keyword-distill',
        name: 'KeywordDistill',
        component: () => import('@/views/KeywordDistill/KeywordDistill.vue'),
        meta: { title: '关键词提炼' },
      },
      {
        path: 'article-generate',
        name: 'ArticleGenerate',
        component: () => import('@/views/ArticleGenerate/ArticleGenerate.vue'),
        meta: { title: '文章生成' },
      },
      {
        path: 'article-library',
        name: 'ArticleLibrary',
        component: () => import('@/views/ArticleLibrary/ArticleLibrary.vue'),
        meta: { title: '文章库' },
      },
      {
        path: 'article-editor/:id',
        name: 'ArticleEditor',
        component: () => import('@/views/ArticleEditor/ArticleEditor.vue'),
        meta: { title: '编辑文章' },
      },
      {
        path: 'settings/llm',
        name: 'LlmKeys',
        component: () => import('@/views/Settings/LlmKeys.vue'),
        meta: { title: '模型密钥' },
      },
    ],
  },
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.public) {
    return next();
  }

  const token = getToken();
  if (!token) {
    return next('/login');
  }

  try {
    await request.get('/api/user/me');
    next();
  } catch (err) {
    next('/login');
  }
});

export default router;
